import { NgModule } from '@angular/core';
import { BackendModule, SearchModule } from '@freelancer/datastore/core';
import { searchFreelancersBackend } from './search-freelancers.backend';
import { transformSearchFreelancers } from './search-freelancers.transformers';

@NgModule({
  imports: [
    SearchModule.forFeature('searchFreelancers', transformSearchFreelancers),
    BackendModule.forFeature('searchFreelancers', searchFreelancersBackend),
  ],
})
export class DatastoreSearchFreelancersModule {}
